import { IMAGES } from "./assets";

// E-commerce-shaped product records. `price` uses { amount, currency, display }
// so a Buy Now / Stripe flow can read the same fields later. For now the CTA
// stays "Enquire About This Part".
export const PRODUCTS = [
  {
    id: "gauge-pod-350z",
    sku: "RP-350Z-GP-01",
    name: "Custom 350Z Gauge Pod",
    tagline: "Triple gauge · CAD-designed",
    chassis: "Nissan 350Z (Z33)",
    price: { amount: null, currency: "AUD", display: "Price on Enquiry" },
    priceOnEnquiry: true,
    specs: [
      "Triple 52mm gauge housing",
      "CAD-mapped to the factory dash",
      "Matte-finish durable 3D print",
      "Right-hand-drive dash — not LHD-only",
    ],
    shippingNote: "Shipping calculated & confirmed with your quote.",
    images: { photo: IMAGES.gaugePodPhoto, wireframe: IMAGES.gaugePodWire },
    cta: "Enquire About This Part",
    available: true,
  },
  {
    id: "cupholder-350z-de",
    sku: "RP-350Z-CH-01",
    name: "Custom 350Z DE Center Console Cupholder",
    tagline: "Cupholder insert · phone + card storage",
    chassis: "Nissan 350Z DE (Z33)",
    price: { amount: 80, currency: "AUD", display: "$80" },
    priceOnEnquiry: false,
    specs: [
      "Integrated phone / card storage slot",
      "Drop-in centre console fitment",
      "Durable matte 3D print",
      "DE chassis specific — custom-fit",
    ],
    shippingNote: "Shipping calculated & confirmed at order.",
    images: { photo: IMAGES.cupholderPhoto, wireframe: IMAGES.cupholderWire },
    cta: "Enquire About This Part",
    available: true,
  },
];

export const ENQUIRY_OPTIONS = [
  ...PRODUCTS.map((p) => p.name),
  "Custom / other part request",
];
